function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.944 12L9 7.234v9.532L16.944 12zm-3.888 0L11 13.234v-2.468L13.056 12z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 2a1 1 0 00-.853.479l-5.5 9a1 1 0 000 1.043l5.5 9A1 1 0 007.5 22h9a1 1 0 00.853-.479l5.5-9a1 1 0 000-1.043l-5.5-9A1 1 0 0016.5 2h-9zM3.172 12L8.06 4h7.878l4.89 8-4.89 8H8.061l-4.89-8z",
  fill: "#4038FF"
});

var SvgVideoNfts = function SvgVideoNfts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi45NDM3IDEyLjAwMDFMOSA3LjIzMzg5VjE2Ljc2NjNMMTYuOTQzNyAxMi4wMDAxWk0xMy4wNTYzIDEyLjAwMDFMMTEgMTMuMjMzOVYxMC43NjYzTDEzLjA1NjMgMTIuMDAwMVoiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjUgMkM3LjE1MTYzIDIgNi44MjgzNyAyLjE4MTMgNi42NDY3MiAyLjQ3ODU1TDEuMTQ2NzIgMTEuNDc4NUMwLjk1MTA5NCAxMS43OTg3IDAuOTUxMDk0IDEyLjIwMTMgMS4xNDY3MiAxMi41MjE1TDYuNjQ2NzIgMjEuNTIxNUM2LjgyODM3IDIxLjgxODcgNy4xNTE2MyAyMiA3LjUgMjJIMTYuNUMxNi44NDg0IDIyIDE3LjE3MTYgMjEuODE4NyAxNy4zNTMzIDIxLjUyMTVMMjIuODUzMyAxMi41MjE1QzIzLjA0ODkgMTIuMjAxMyAyMy4wNDg5IDExLjc5ODcgMjIuODUzMyAxMS40Nzg1TDE3LjM1MzMgMi40Nzg1NUMxNy4xNzE2IDIuMTgxMyAxNi44NDg0IDIgMTYuNSAySDcuNVpNMy4xNzE5NSAxMkw4LjA2MDgzIDRIMTUuOTM5MkwyMC44MjgxIDEyTDE1LjkzOTIgMjBIOC4wNjA4M0wzLjE3MTk1IDEyWiIgZmlsbD0iIzQwMzhGRiIvPgo8L3N2Zz4K";
export { SvgVideoNfts as ReactComponent };